// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                                   from 'firebase/functions';

// ===== Interfaces =====

import {
    IRequestGeneratedPostAudioNoteSpeechArgs,
    IRequestGeneratedPostAudioNoteSpeechResult,
}                                                   from '../interfaces';

/**
 * Creates the media document for a generated post dictation audio note and
 * asks the backend speech worker to synthesize and align the audio after save.
 */
const requestGeneratedPostAudioNoteSpeech = async (
    args: IRequestGeneratedPostAudioNoteSpeechArgs,
): Promise<IRequestGeneratedPostAudioNoteSpeechResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        IRequestGeneratedPostAudioNoteSpeechArgs,
        IRequestGeneratedPostAudioNoteSpeechResult
    >(
        functions,
        'createGeneratedPostAudioNoteSpeech',
    );

    return callable(args).then((result) => result.data);
};

export default requestGeneratedPostAudioNoteSpeech;
